import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


// 全局引入初始化css样式
import './assets/css/reset.css'
//引入element ui及elment样式并且全局挂载
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

//全局导入mock.js的配置
import './mock/mock.js'


//全局导入mock.js的配置
import './mock/mock.js'
//全局引入axios  相当于ajax   用于发送网络请求
//from后面不佳路径的话 会自动去node——modules文件夹下找
import axios from "axios"
//请求超时
axios.defaults.timeout = 5000;
//配置默认的请求域名
//axios.defaults.baseURL = '/';
//axios.defaults.baseURL = 'https://yq.jumh.cn/gy-app-apis/';
axios.defaults.baseURL = 'http://111.6.219.213:8082/gy-app-apis/';
//联调(联合开发、联合调试)
//请求拦截
//请求开始和结束
axios.interceptors.request.use(
  function (config) {
    console.log('开始加载', config);
    return config;
  },
  //promise中俩个参数  reject   resolve
  function (err) {
    Promise.reject(err);
  }
)
//请求成功和失败 
axios.interceptors.response.use(
  function (res) {
    console.log(res);
    return res;
  },
  //处理错误
  function (err) {
    Promise.reject(err)
  }
)
if (sessionStorage.getItem("token")) {
  axios.defaults.headers.post['Authorization'] = 'Bearer ' + sessionStorage.getItem("token")
  axios.defaults.headers.get['Authorization'] = 'Bearer ' + sessionStorage.getItem("token")
}

//axios默认配置

//把axios 挂载到vue全局的原型中的$http方法上
Vue.prototype.$http = axios
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
